import React, { useState } from "react";
import CasesInfo from "../../../../components/client/actions/CasesInfo";
import { useSelector } from "react-redux";
import DirectionAdd from "../../../../components/admin/actions/DirectionAdd";
import DirectionEdit from "../../../../components/admin/actions/DirectionEdit";

export default function Directions() {
  const [caseInfo, setCaseInfo] = useState(false);
  const [caseInfoId, setCaseInfoId] = useState("0");
  const [directionId, setDirectionId] = useState("0");
  const [directionEdit, setDirectionEdit] = useState(false);
  const [directionAdd, setDirectionAdd] = useState(false);

  const data = useSelector((state) => state.main.data?.instructionsData);
  const handlerClickDir = (id) => {
    setCaseInfo(true);
    setCaseInfoId(`${id}`);
  };
  const handlerEditDir = (id) => {
    setDirectionEdit(true);
    setDirectionId(`${id}`);
  };

  return (
    <>
      <section className="directions-home">
        <div className="background">
          <img src="/images/BGg.png" alt="" />
        </div>
        <div className="head-title">
          <div className="title">
            <span>تعليمات للمرضى بعد اجراء العمليات </span>{" "}
            <div className="add-icon" onClick={() => setDirectionAdd(true)}>
              <lord-icon
                src="https://cdn.lordicon.com/jgnvfzqg.json"
                trigger="hover"
                className="img"
                style={{ width: "50px", height: "50px" }}
              ></lord-icon>
            </div>
          </div>
        </div>
        <div className="box">
          {data?.map((direction) => (
            <div
              className="direction"
              key={direction?.id}
              onClick={() => handlerClickDir(direction?.id)}
              data-aos="fade-up"
            >
              <div
                className="edit-icon"
                onClick={() => handlerEditDir(direction?.id)}
              >
                <img src="/images/edit-text.png" alt="" />
              </div>
              <div className="image">
                <img
                  src={`https://api.atharalfarasha.com/public/hakim/${direction?.instruction_photo}`}
                  alt=""
                />
              </div>
              <div className="title">{direction?.instruction_name}</div>
            </div>
          ))}
        </div>
      </section>
      <DirectionAdd
        directionAdd={directionAdd}
        setDirectionAdd={setDirectionAdd}
      />
      <DirectionEdit
        directionEdit={directionEdit}
        setDirectionEdit={setDirectionEdit}
        directionId={directionId}
      />
    </>
  );
}
